import React from 'react';
import { InvoiceMeta as InvoiceMetaType } from '../models/invoice';

interface Props {
    meta: InvoiceMetaType;
    onChange: (field: string, value: string) => void;
    hiddenFields: { [key: string]: boolean };
    onToggleVisibility: (field: string) => void;
}

const InvoiceMeta: React.FC<Props> = ({ meta, onChange, hiddenFields, onToggleVisibility }) => {
    const handleInput = (field: keyof InvoiceMetaType, value: string) => {
        onChange(field, value);
    };

    return (
        <div style={styles.grid}>
            <div style={{ ...styles.formGroup, ...(hiddenFields['series'] ? styles.hiddenField : {}) }}>
                <label style={styles.label}>
                    Serija
                    <input
                        type="checkbox"
                        checked={!hiddenFields['series']}
                        onChange={() => onToggleVisibility('series')}
                        style={styles.visibilityToggle}
                    />
                </label>
                <input
                    type="text"
                    value={meta.series}
                    onChange={(e) => handleInput('series', e.target.value)}
                    placeholder="SF"
                    style={styles.input}
                    disabled={hiddenFields['series']}
                />
            </div>
            <div style={{ ...styles.formGroup, ...(hiddenFields['number'] ? styles.hiddenField : {}) }}>
                <label style={styles.label}>
                    Numeris
                    <input
                        type="checkbox"
                        checked={!hiddenFields['number']}
                        onChange={() => onToggleVisibility('number')}
                        style={styles.visibilityToggle}
                    />
                </label>
                <input
                    type="text"
                    value={meta.number}
                    onChange={(e) => handleInput('number', e.target.value)}
                    placeholder="00001"
                    style={styles.input}
                    disabled={hiddenFields['number']}
                />
            </div>
            <div style={{ ...styles.formGroup, ...(hiddenFields['date'] ? styles.hiddenField : {}) }}>
                <label style={styles.label}>
                    Data
                    <input
                        type="checkbox"
                        checked={!hiddenFields['date']}
                        onChange={() => onToggleVisibility('date')}
                        style={styles.visibilityToggle}
                    />
                </label>
                <input
                    type="date"
                    value={meta.date}
                    onChange={(e) => handleInput('date', e.target.value)}
                    style={styles.input}
                    disabled={hiddenFields['date']}
                />
            </div>
            <div style={{ ...styles.formGroup, ...(hiddenFields['dueDate'] ? styles.hiddenField : {}) }}>
                <label style={styles.label}>
                    Apmokėti iki
                    <input
                        type="checkbox"
                        checked={!hiddenFields['dueDate']}
                        onChange={() => onToggleVisibility('dueDate')}
                        style={styles.visibilityToggle}
                    />
                </label>
                <input
                    type="date"
                    value={meta.dueDate}
                    onChange={(e) => handleInput('dueDate', e.target.value)}
                    style={styles.input}
                    disabled={hiddenFields['dueDate']}
                />
            </div>
        </div>
    );
};

const styles: { [key: string]: React.CSSProperties } = {
    grid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
        gap: '20px',
    },
    formGroup: {
        marginBottom: '15px',
        position: 'relative', // For absolute positioning of toggle if needed
    },
    label: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '5px',
        fontWeight: 'bold',
        fontSize: '0.9rem',
        color: '#555',
    },
    input: {
        width: '100%',
        padding: '8px',
        border: '1px solid #ccc',
        borderRadius: '4px',
        fontSize: '1rem',
    },
    hiddenField: {
        opacity: 0.5,
        backgroundColor: '#f0f0f0',
        pointerEvents: 'none', // Disable interactions
    },
    visibilityToggle: {
        marginLeft: 'auto', // Push to the right
        marginRight: '5px',
        width: '16px',
        height: '16px',
        cursor: 'pointer',
        pointerEvents: 'all', // Re-enable interaction for the toggle itself
    }
};

export default InvoiceMeta;
